import { useAuth } from "../../context/auth-context";
import type {
  AdminBillPaymentSummariesData,
  AdminBillPaymentSummariesEnvelope,
} from "./adminBillPaymentSummaries";
import { apiQueryKey } from "./queryKeys";
import { useApiQuery } from "./useApiQuery";

export type UseAdminBillPaymentSummariesParams = {
  startDate?: string;
  endDate?: string;
  enabled?: boolean;
};

/**
 * GET api/admin/transactions/summaries?type=billpayment[&startDate][&endDate]
 */
export function useAdminBillPaymentSummariesQuery(
  params: UseAdminBillPaymentSummariesParams = {}
) {
  const { isAuthenticated } = useAuth();
  const { startDate, endDate, enabled: enabledParam = true } = params;

  return useApiQuery<
    AdminBillPaymentSummariesEnvelope,
    AdminBillPaymentSummariesData
  >({
    queryKey: apiQueryKey("admin-transactions-summaries", {
      type: "billpayment",
      startDate: startDate ?? null,
      endDate: endDate ?? null,
    }),
    url: "api/admin/transactions/summaries",
    params: {
      type: "billpayment",
      startDate,
      endDate,
    },
    enabled: Boolean(isAuthenticated) && enabledParam,
    select: (body) => body.data,
  });
}
